module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vh-100 overflow-y-scroll"
  }, [_c('div', {
    staticClass: "flex flex-nowrap pa2"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_vm._v(" Go back ")]), _vm._v(" "), _c('h1', {
    staticClass: "mh4"
  }, [_vm._v("School/District Management Portal")]), _vm._v(" "), _c('pl-button', {
    class: {
      selected: _vm.page === 'school'
    },
    attrs: {
      "disabled": _vm.page === 'school'
    },
    nativeOn: {
      "click": function($event) {
        _vm.page = 'school'
      }
    }
  }, [_vm._v("\n      School\n    ")]), _vm._v(" "), _c('pl-button', {
    class: {
      selected: _vm.page === 'district'
    },
    attrs: {
      "disabled": _vm.page === 'district'
    },
    nativeOn: {
      "click": function($event) {
        _vm.page = 'district'
      }
    }
  }, [_vm._v("\n      District\n    ")]), _vm._v(" "), _c('pl-button', {
    class: {
      selected: _vm.page === 'users'
    },
    attrs: {
      "disabled": _vm.page === 'users'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToPageUsers()
      }
    }
  }, [_vm._v("\n      Users\n    ")])], 1), _vm._v(" "), (_vm.page === 'school') ? _c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Create New School")]), _vm._v(" "), _c('div', {}, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        _vm.edit_school_modal = true
      }
    }
  }, [_vm._v("\n        Create New School\n      ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("School List")]), _vm._v(" "), _c('pl-input', {
    attrs: {
      "labelText": "Search By School Name"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.searchBySchoolName.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.school_query),
      callback: function($$v) {
        _vm.school_query = $$v
      },
      expression: "school_query"
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.schools), function(school) {
    return _c('li', {
      staticClass: "row middle-xs between-xs school-list",
      on: {
        "click": function($event) {
          return _vm.goToAdminPortal(school)
        },
        "mouseenter": function($event) {
          return _vm.hoverSchool(school.id)
        },
        "mouseleave": function($event) {
          _vm.hovered = false
        }
      }
    }, [_c('span', {
      staticClass: "school-title pl-title"
    }, [_vm._v("\n          " + _vm._s(school.name) + "\n        ")]), _vm._v(" "), (school.id === _vm.hovered) ? _c('pl-menu', {
      attrs: {
        "menuSize": 4,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      staticStyle: {
        "color": "#e53935"
      },
      on: {
        "click": function($event) {
          return _vm.schoolToDelete(school.id)
        }
      }
    }, [_vm._v("\n              Remove School\n              "), _c('i', {
      staticClass: "fas fa-trash-alt",
      staticStyle: {
        "color": "#e53935"
      }
    })])])], 1) : _vm._e()], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.page === 'users') ? _c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("View Users")]), _vm._v(" "), _c('pl-input', {
    attrs: {
      "labelText": "Search User By Email"
    },
    model: {
      value: (_vm.user_query),
      callback: function($$v) {
        _vm.user_query = $$v
      },
      expression: "user_query"
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.searchByUserEmail.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Search\n    ")]), _vm._v(" "), _c('ul', _vm._l((_vm.users), function(user) {
    return _c('li', {
      staticClass: "pl-title school-in-list",
      on: {
        "click": function($event) {
          return _vm.selectUser(user)
        }
      }
    }, [_vm._v("\n        " + _vm._s(user.name) + " - " + _vm._s(user.email) + " - " + _vm._s(user.role) + "\n      ")])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.page === 'district') ? _c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Create New District")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {}, [_c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": true
    },
    nativeOn: {
      "click": function($event) {}
    }
  }, [_vm._v("\n        Create New District\n      ")]), _vm._v("\n      (Disabled for now because I'm assuming districts will only be created by\n      clever for now?)\n    ")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("District List")]), _vm._v(" "), _c('ul', _vm._l((_vm.districts), function(district) {
    return _c('li', {
      staticClass: "pl-title school-in-list",
      on: {
        "click": function($event) {
          return _vm.selectDistrict(district.id)
        }
      }
    }, [_vm._v("\n        " + _vm._s(district.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.show_delete_school_modal) ? _c('dialog-delete-confirm', {
    attrs: {
      "subHeader": _vm.contentMessageToRemove,
      "optionalText": "School"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_school_modal = false
      },
      "actionConfirmed": _vm.removeSchool
    }
  }) : _vm._e(), _vm._v(" "), (_vm.edit_school_modal) ? _c('edit-school-modal', {
    on: {
      "close": function($event) {
        _vm.edit_school_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("\n      NOTE: Do not create districts here that will be synced through Clever.\n      "), _c('br'), _vm._v("\n      The district will show up here after the inital sync.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7b723b46!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/schoolManagement.vue
// module id = 1970
// module chunks = 61